import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import "../styles/categories.css";

// Lantern images
const lanternIdle = "/cards lantern/idle lantern.png";
const lanternMoving = "/cards lantern/moving lantern.png";

function Categories() {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);

  const categories = [
    {
      id: "zelige",
      name: "Zelige",
      galleryName: "Zelige",
      description: "Carreaux de mosaïque traditionnels marocains",
      image: "/themes/zelige.png",
      color: "hsl(42, 80%, 55%)", // Gold
      count: 0,
    },
    {
      id: "boiserie",
      name: "Boiserie",
      galleryName: "Boiserie",
      description: "Panneaux et ornements en bois sculpté",
      image: "/themes/woodwork.png",
      color: "hsl(15, 60%, 45%)", // Terracotta
      count: 0,
    },
    {
      id: "platre",
      name: "Plâtre",
      galleryName: "Platre",
      description: "Décorations et moulures en plâtre",
      image: "/themes/plaster.png",
      color: "hsl(35, 40%, 75%)", // Sand
      count: 0,
    },
    {
      id: "ferronnerie",
      name: "Ferronnerie",
      galleryName: "Ferronnerie",
      description: "Éléments de ferronnerie et métallerie",
      image: "/themes/ferronnerie.png",
      color: "hsl(40, 70%, 50%)", // Gold
      count: 0,
    },
  ];

  const handleCategoryClick = (categoryName) => {
    navigate(`/gallery/category/${categoryName}`, {
      state: { category: categoryName },
    });
  };

  // Container animation for staggered children
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  // Card animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <div className="categories-page">
      <div className="categories-header">
        <motion.h1
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
        >
          Catégories
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.6,
            delay: 0.15,
            ease: [0.25, 0.1, 0.25, 1],
          }}
          className="categories-subtitle"
        >
          Explorez notre collection organisée par type d'élément architectural
        </motion.p>
      </div>

      <motion.div
        className="categories-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {categories.map((category) => {
          const isHovered = hoveredCard === category.id;
          return (
            <motion.div
              key={category.id}
              className={`category-card ${isHovered ? 'is-hovered' : ''}`}
              variants={cardVariants}
              onMouseEnter={() => setHoveredCard(category.id)}
              onMouseLeave={() => setHoveredCard(null)}
              whileHover={{
                y: -8,
                transition: {
                  duration: 0.3,
                  ease: "easeOut",
                },
              }}
              whileTap={{
                scale: 0.98,
                transition: { duration: 0.1, ease: "easeOut" },
              }}
              onClick={() => handleCategoryClick(category.galleryName)}
            >
              {/* Lantern decoration */}
              <div className="lantern-wrapper">
                <img 
                  src={lanternIdle} 
                  alt="" 
                  className="lantern lantern-idle"
                />
                <img 
                  src={lanternMoving} 
                  alt="" 
                  className="lantern lantern-moving"
                />
                <div className="lantern-glow"></div>
              </div>

              {/* Card content */}
              <div className="category-card-content">
                <div className="category-icon-wrapper" style={{ "--category-color": category.color }}>
                  {category.image ? (
                    <img 
                      src={category.image} 
                      alt={category.name}
                      className="category-image"
                    />
                  ) : (
                    <div className="category-placeholder">
                      <span>+</span>
                    </div>
                  )}
                </div>
                
                <h2 className="category-title">{category.name}</h2>
                <p className="category-desc">{category.description}</p>
                
                <motion.button
                  className="category-btn"
                  whileHover={{
                    x: 4,
                    transition: { duration: 0.3, ease: "easeOut" },
                  }}
                  whileTap={{
                    scale: 0.97,
                    transition: { duration: 0.1, ease: "easeOut" },
                  }}
                >
                  Explorer <FaArrowRight />
                </motion.button>
              </div>

              {/* Decorative corner accents */}
              <div className="card-corner card-corner-tl"></div>
              <div className="card-corner card-corner-tr"></div>
              <div className="card-corner card-corner-bl"></div>
              <div className="card-corner card-corner-br"></div>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
}

export default Categories;
